import { useMessages } from '@odin/services';

/**
 * Quasar version 1 has incompatible validation methods compared to version 2. As we are using components
 * from version 2 in @odin/components-vue2, we need to ensure that validation works correctly.
 * Use is providing validation class that is needed to be added to version 2 components that should run through
 * validation in forms. After that, v1 validation mechanism will count these components into v1 components and
 * run validation on them.
 */
export const quasarV2Validation = (validationPaths: string[]) => {
  const { postMessage, subscribeTopic } = useMessages();
  const v2ValidationClass = 'q2-validation-component';

  let hasErrors = false;
  const validateFields = (): Promise<boolean> => {
    postMessage(
      'cart.validator',
      `update${Date.now()}`,
      validationPaths
    );
    return Promise.resolve(!hasErrors);
  };

  const subscribeToResults = () => {
    validationPaths.forEach((validationPath: string) => {
      subscribeTopic(
        `${validationPath}.result`,
        (result: { value: string }) => {
          if (typeof result.value === 'undefined') {
            return;
          }
          hasErrors = result.value !== 'true';
        }
      );
    });
  };

  return { v2ValidationClass, validateFields, subscribeToResults };
};
